var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanoFamilia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 18.0682C40 19.0909 38 19.7727 35.6667 20.1136C34.1667 17.2159 31.1667 15 27.6667 13.4659C28 12.9545 28.3333 12.6136 28.6667 12.1023H30C35.1667 11.9318 40 15.1705 40 18.0682ZM11.3333 11.9318H10C4.83333 11.9318 0 15.1705 0 18.0682C0 19.0909 2 19.7727 4.33333 20.1136C5.83333 17.2159 8.83333 15 12.3333 13.4659L11.3333 11.9318ZM20 13.6364C23.6667 13.6364 26.6667 10.5682 26.6667 6.81818C26.6667 3.06818 23.6667 0 20 0C16.3333 0 13.3333 3.06818 13.3333 6.81818C13.3333 10.5682 16.3333 13.6364 20 13.6364ZM20 15.3409C13.1667 15.3409 6.66667 19.7727 6.66667 23.8636C6.66667 27.2727 20 27.2727 20 27.2727C20 27.2727 33.3333 27.2727 33.3333 23.8636C33.3333 19.7727 26.8333 15.3409 20 15.3409ZM29.5 10.2273H30C32.8333 10.2273 35 8.01136 35 5.11364C35 2.21591 32.8333 0 30 0C29.1667 0 28.5 0.170455 27.8333 0.511364C29.1667 2.21591 30 4.43182 30 6.81818C30 8.01136 29.8333 9.20455 29.5 10.2273ZM10 10.2273H10.5C10.1667 9.20455 10 8.01136 10 6.81818C10 4.43182 10.8333 2.21591 12.1667 0.511364C11.5 0.170455 10.8333 0 10 0C7.16667 0 5 2.21591 5 5.11364C5 8.01136 7.16667 10.2273 10 10.2273Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanoFamilia);
export default __webpack_public_path__ + "static/media/plano-familia.086b26b87d786d3f2b0169c00ce191d9.svg";
export { ForwardRef as ReactComponent };